// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vuesax-app-is-ltr  {\n  font-weight: bold;\n  font-size: 1rem;\n  color: #242426;\n}[dir] .vuesax-app-is-ltr  {\n  margin-top: 2rem !important;\n}\n", ""]);
// Exports
module.exports = exports;
